import { render, staticRenderFns } from "./CopyCalendareventComponent.vue?vue&type=template&id=761f80ea&"
import script from "./CopyCalendareventComponent.vue?vue&type=script&lang=js&"
export * from "./CopyCalendareventComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports